module.exports = __webpack_public_path__ + "media/images/icons/heartrate-415ed6e3ea3177f1208b10a95adecc32.svg";